import React, {ReactElement} from 'react';
import {Center} from 'components/Center';
import {Congrats} from 'components/Congrats';
import {NewDayOptions} from 'components/NewDayOptions';

export const NewDayScreen = (): ReactElement => (
  <Center>
    <Congrats />
    <NewDayOptions />
  </Center>
);
